"use client";

import { sendGTMEvent } from "@next/third-parties/google";

export const useTagging = () => {
  const dataLayer =
    typeof window !== "undefined" ? (window.dataLayer ?? []) : [];

  const setTag = (
    eventPayload: Record<string, unknown>,
    options: SetTagOptions = {},
  ) => {
    if (options.reset) {
      sendGTMEvent({ ecommerce: null });
    }

    const { formEvent, ...rest } = eventPayload;

    if (formEvent && typeof window !== "undefined" && window.analyticsObj) {
      window.analyticsObj = {
        ...window.analyticsObj,
        formEvent: formEvent as Record<string, string>,
      };
    }

    sendGTMEvent(rest);
  };

  return [dataLayer, setTag] as const;
};

type SetTagOptions = {
  reset?: boolean;
};

export default useTagging;
